module.exports = __webpack_public_path__ + "img/AboutUs01.ba24671b.jpg";